
import { SET_ASIDE_SHOW, SET_SIDEBAR_SHOW, SET_SIDEBAR_UNFOLDABLE, SET_THEME } from "../const";

export const setSidebarShow = (value) => ({ type: SET_SIDEBAR_SHOW, value });
export const setAsideShow = (value) => ({ type: SET_ASIDE_SHOW, value });
export const setSideBarUnfoldable = (value) => ({ type: SET_SIDEBAR_UNFOLDABLE, value });
export const setTheme = (value) => ({ type: SET_THEME, value });